import {copyText} from '@github-ui/copy-to-clipboard'
import {CopyIcon, GitCommitIcon, HourglassIcon} from '@primer/octicons-react'
import {Box, TextInput} from '@primer/react'
import {Blankslate} from '@primer/react/drafts'

import {useFilters} from '../../contexts/FilterContext'
import {Panel} from '../Panel'

export function CommitsBlankState({timeoutMessage}: {timeoutMessage: string}) {
  const filters = useFilters()

  if (timeoutMessage !== '') {
    return (
      <Panel>
        <Box data-hpc>
          <Blankslate>
            <Blankslate.Visual>
              <HourglassIcon />
            </Blankslate.Visual>
            <Blankslate.Heading>Sorry, this commit history is taking too long to generate. </Blankslate.Heading>
            <Blankslate.Description>
              <>Refresh the page to try again, or view this history locally using this command:</>
              <TextInput
                aria-label={'View commit history locally command'}
                value={timeoutMessage}
                readOnly
                onChange={() => {
                  //noop, don't want to do anything
                }}
                trailingAction={
                  <TextInput.Action
                    onClick={() => {
                      copyText(timeoutMessage)
                    }}
                    icon={CopyIcon}
                    aria-label="Copy to clipboard"
                    sx={{color: 'fg.subtle'}}
                  />
                }
                sx={{display: 'flex', justifyContent: 'center'}}
              />
            </Blankslate.Description>
          </Blankslate>
        </Box>
      </Panel>
    )
  }
  return (
    <Panel>
      <Box data-hpc>
        <Blankslate>
          <Blankslate.Visual>
            <GitCommitIcon />
          </Blankslate.Visual>
          <Blankslate.Heading>No commits history</Blankslate.Heading>
          <Blankslate.Description>
            <>
              There isn&apos;t any commit history to show here
              {filters.since !== null || filters.until !== null ? ' for the selected date range' : ''}
            </>
          </Blankslate.Description>
        </Blankslate>
      </Box>
    </Panel>
  )
}

try{ CommitsBlankState.displayName ||= 'CommitsBlankState' } catch {}